export class ProductMedia {}

export class ProductImage extends ProductMedia {
    image: Queries.ProductsJsonFieldsImages;

    constructor(image: Queries.ProductsJsonFieldsImages) {
        super();
        this.image = image;
    }
}

export class ProductVideo extends ProductMedia {
    videoId: string;
    public thumbnailUrl: string = '';

    constructor(videoId: string) {
        super();
        this.videoId = videoId;
    }
}
